import React from 'react';

const PeopleListPage: React.FC = () => {
  return (
    <>
      <style>
        {`
          .people-list-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 100vh;
            padding: 40px;
            background: #f9fafb;
          }
          
          .empty-state {
            text-align: center;
            max-width: 400px;
          }
          
          .empty-icon {
            width: 80px;
            height: 80px;
            margin: 0 auto 24px;
            background: #e5e7eb;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .empty-icon i {
            font-size: 32px;
            color: #9ca3af;
          }
          
          .empty-title {
            font-size: 24px;
            font-weight: 600;
            color: #1f2937;
            margin: 0 0 12px 0;
          }
          
          .empty-description {
            font-size: 16px;
            color: #6b7280;
            line-height: 1.5;
            margin: 0 0 32px 0;
          }
          
          .empty-badge {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 8px 16px;
            background: #dbeafe;
            color: #1d4ed8;
            border-radius: 20px;
            font-size: 14px;
            font-weight: 500;
          }
          
          .empty-badge i {
            font-size: 16px;
          }
        `}
      </style>
      
      <div className="people-list-container">
        <div className="empty-state">
          <div className="empty-icon">
            <i className="ri-team-line"></i>
          </div>
          
          <h1 className="empty-title">인원 리스트</h1>
          
          <p className="empty-description">
            인원 관리를 위한 새로운 페이지입니다.<br />
            언젠가 개발 예정입니다.
          </p>
          
          <div className="empty-badge">
            <i className="ri-time-line"></i>
            <span>개발 예정</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default PeopleListPage; 